import router from '../../../router'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputButton from '../../../components/input-button/InputButton'
import InputText from '../../../components/input-text/InputText'
import Loader from '../../../components/loader/Loader'
import { SortedTable, SortLink } from 'vue-sorted-table'
import { ScreenLoader } from '../../../utils/loading.util'
import { CustomerService, Customer } from '../../../services/customer.service'
import InputDropdown from "@/components/input-dropdown/InputDropdown";
import {LocationDropdown, LocationService} from "@/services/location.service";

export default {
    name: 'Customers',
    components: {
        InputDropdown,
        NavigationBar,
        TabBar,
        InputButton,
        InputText,
        SortedTable,
        SortLink,
        Loader
    },

    data() {
        return {
            searchValue: undefined,
            customers: [],
            screenLoader: new ScreenLoader(),
            locations: [new LocationDropdown({id: -1, name: "Show all locations"})],
            selectedLocation: new LocationDropdown({id: -1, name: "Show all locations"})
        }
    },

    async mounted() {
        await this.getCustomers()
        const locations = await LocationService.getLocations()
        this.locations = [...this.locations, ...locations.map(l => new LocationDropdown(l))]
    },

    computed: {
        sortedCustomers () {
            if (this.selectedLocation.id != -1) {
                return this.customers.filter((customer) => {
                    return customer.locations.find((location) => location.id.toString() === this.selectedLocation.id) !== undefined
                })
            } else {
                if (this.searchValue == undefined || this.searchValue == '') {
                    return this.customers
                } else {

                    return this.customers.filter((customer) => {
                        const foundName = this.propertyContainsValue(customer.name)
                        const foundLocation = this.propertyContainsValue(customer.locationLabels)
                        return foundName || foundLocation
                    })
                }
            }
        }
    },

    methods: {
        doAdd() {
            router.push(`/settings/customers/new`)
        },

        selectRow(rowId) {
            router.push(`/settings/customers/${rowId}`)
        },

        propertyContainsValue(value) {
            return value ? value.toLowerCase().includes(this.searchValue.toLowerCase()) : false
        },

        clearSearch() {
            this.searchValue = ''
            this.sortedCustomers = _.sortBy(this.customers, 'name')
        },

        getCustomers: async function() {
            this.screenLoader.start()

            try {
                const customers = await CustomerService.getCustomers(true)
                this.handleCustomersResponse(customers)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        handleCustomersResponse(customers) {
            this.customers = _.sortBy(customers, 'name').map(o => new Customer(o))
            this.sortedCustomers = _.sortBy(this.customers, 'name')

            this.screenLoader.stop()
        },

        updateLocationFilter(locationId) {
            this.selectedLocation = this.locations.find(l => l.id === locationId)
        },

        customerClass(customer) {
            if (customer.active) {
                return 'sorted-table-row'
            } else {
                return 'sorted-table-row-inactive'
            }
        }
    }
}
